import React, { Component } from 'react'
import img from '../../images/room-svc/sub_meals/sub_meal01.png'
import img2 from '../../images/room-svc/sub_meals/sub_meal02.png'
import img3 from '../../images/room-svc/sub_meals/sub_meal03.png'
import img4 from '../../images/room-svc/sub_meals/sub_meal04.png'
import { connect } from 'react-redux'
//import BackgroundImageOnLoad from 'background-image-on-load';
import propTypes from 'prop-types';
import { CMSPath } from '../../config/constant'
import { changePage, selectedSubItem, getSubItemType, setDefaultSubTypeList } from '../../action/hcommerce'
import defaultImage from '../../images/cover_breakfast.png'
import { hCommButtonColor } from '../../JS/setColors'

class StoreSubItemType extends Component {
    goBack = () => {
        this.props.changePage("StoreItemTypeList");
    }

    goToItemPage = (nextPage, subItemType) => {
        this.props.changePage(nextPage);
        this.props.selectedSubItem(subItemType);
    }

    componentDidMount() {
        this.props.getSubItemType(this.props.guestDetail, this.props.StoreItemType.id);
        hCommButtonColor(this.props.menuColor)
    }

    componentWillUnmount() {
        console.log("setDefaultSubTypeList");
        this.props.setDefaultSubTypeList([]);
    }
    
    render() {
        let imagePath;
        //console.log("itemSubTypeList", this.props.itemSubTypeList);
        return (
            <div id="rs-menu-list" class="movie-widgets" style={{ color: "inherit" }}>
                <div class="search-back" data-target="rs-main" onClick={this.goBack}>
                    <i class="fa fa-chevron-left" style={{ color: "inherit" }}></i> Back</div>
                <h4 style={{ color: "inherit" }}>{this.props.StoreItemType && this.props.StoreItemType.typeName ? this.props.StoreItemType.typeName : null}</h4>
                <ul class="movie-widgets-list">
                    {this.props.itemSubTypeList ?
                        this.props.itemSubTypeList.map((iterator) => {

                            if (iterator.storeItemSubTypeImages.length === 1) {
                                imagePath = `${CMSPath}${iterator.storeItemSubTypeImages[0].imagePath}`
                            } else {
                                iterator.storeItemSubTypeImages.map((images) => {
                                    if (images.imageType === "LARGE") {
                                        imagePath = encodeURI(`${CMSPath}${images.imagePath}`)
                                    }
                                })
                            }
                            if (iterator.storeItemSubTypeImages.length === 0) {
                                imagePath = defaultImage
                            }
                            return (
                                <li id={`storeSubItem${iterator.id}`}
                                    onClick={() => { this.goToItemPage("ItemPage", iterator) }}
                                    data-target="rs-item-list"
                                    style={{
                                        background: `url(${imagePath}) center center no-repeat`,
                                        backgroundSize: "cover"
                                    }}
                                >
                                    {/* <BackgroundImageOnLoad
                                        src={imagePath}
                                        onLoadBg={() =>
                                            console.log("on backgroundImageLoad")
                                        }
                                    /> */
                                    }
                                    <a ><span>{iterator.subTypeName}</span></a>
                                </li>
                            )
                        }) : null
                    }
                </ul>
            </div>
        )
    }
}

const mapStateToProps = state => {
    return {
        guestDetail: state.store.home.guestDetails,
        StoreItemType: state.store.Hcommerce.StoreItemType,
        itemSubTypeList: state.store.Hcommerce.itemSubTypeList,
        menuColor: state.store.home.MenuColor
    }
}

export default connect(
    mapStateToProps,
    {
        changePage,
        selectedSubItem,
        getSubItemType,
        setDefaultSubTypeList
    }
)(StoreSubItemType);

/*
                    <li onClick={() => { this.goToItemPage("ItemPage", "Meal 1") }}
                        data-target="rs-item-list"
                        style={{
                            background: `url(${img}) center center no-repeat`,
                            backgroundSize: "cover"
                        }}>
                        <a ><span>Meal 1</span></a>
                    </li>
*/